module.exports = __webpack_public_path__ + "img/Tail_feathers_MetalRoughness.c20031c.jpg";